import { Component } from "react";
import { Red2 } from "styles/antTheme/Colors";

import { MenuItemName } from "types/enum";

import { routes } from "utilities/routes";

import { BTIconCloseCircleError } from "commonComponents/btWrappers/BTIcon";
import { BTLinkRelative } from "commonComponents/btWrappers/BTLink/BTLink";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import { type IBannerAlertProps } from "commonComponents/utilities/HeaderAlerter/HeaderAlerter.types";

import { RouteSubscriptionManager } from "entity/SubscriptionManager/SubscriptionManagerRoute";

class LeadEmailOverageBanner extends Component<IBannerAlertProps> {
    render() {
        const { selectedMenuItem, match, alert } = this.props;

        switch (selectedMenuItem) {
            case MenuItemName.LeadOpportunities:
                return (
                    <>
                        <RouteSubscriptionManager
                            modalConfig={{
                                beforeClose: () => {
                                    this.props.history.replace(this.props.match.url);

                                    // todo replace with context reload once site is Single Page App (SPA)
                                    window.location.reload();
                                },
                                parentRoute: match.url,
                            }}
                        />
                        <div
                            className="flex align-items-center padding-all-md"
                            style={{ borderRadius: 8, background: Red2 }}
                        >
                            <div className="margin-left-lg">
                                <BTTitle level={3} bold>
                                    <BTIconCloseCircleError className="padding-right-md" />
                                    {alert.alertTitle}
                                    <BTLinkRelative
                                        to={routes.subscriptionManager.getSettingsLink(
                                            false,
                                            false,
                                        )}
                                        className="padding-left-md"
                                    >
                                        Upgrade Now
                                    </BTLinkRelative>
                                </BTTitle>
                                <div>{alert.alertText}</div>
                            </div>
                        </div>
                    </>
                );

            default:
                return null;
        }
    }
}

export default LeadEmailOverageBanner;
